import Styles from './index.module.scss'
import Link from 'next/link';
import Image from 'next/image';
import Car from './images/car.png'
const LogisticsEntity = ({ logisticsCount }) => {
    return <Link href={'/logistics/list'}>
        <div className={Styles.logistics_box}>
            <div className={Styles.img_box}>
                <Image src={Car} width={86} height={54} alt="" style={{marginTop: '30px'}} />
            </div>
            <div className={Styles.right}>
                <div className={Styles.text}>在途订单物流轨迹 <span className={Styles.num}>{logisticsCount}</span></div>
                <div className={Styles.btn}>去看看</div>
            </div>
        </div>
    </Link>
}

export default LogisticsEntity;